import React from 'react';
import { Link } from 'react-router-dom';
const Banner = () => {

  const scrollToProductSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" }); 
    }
  };
  return (
    <div
      className="hero-area hero-bg"
      style={{
        backgroundImage: "url(../assets/img/hero-bg.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center", 
        backgroundRepeat: "no-repeat",
        height: "100vh", 
        width: "100%", 
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-9 offset-lg-2 text-center">
            <div className="hero-text">
              <div className="hero-text-tablecell">
                <h1>Buy Anything with Your Cryptocurrency</h1>
                <div className="hero-btns">
                  <Link  className="bordered-btn" onClick={() => scrollToProductSection("product_section")}>
                    Shop Now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
